// Constantes y helpers compartidos por la página admin (Sorteos) y la página
// pública (/sorteo). Las functions viven en functions/raffles.js.

export const RAFFLES_COLLECTION = 'raffles';
export const SALES_COLLECTION = 'raffle-sales';
export const TICKETS_COLLECTION = 'raffle-tickets';

const FN = 'https://us-central1-bb-target-center.cloudfunctions.net';
export const FN_URLS = {
  adminSale: `${FN}/raffleAdminSale`,
  recordPayment: `${FN}/raffleRecordPayment`,
  sendLink: `${FN}/raffleSendLink`,
  cancelSale: `${FN}/raffleCancelSale`,
  resendReceipt: `${FN}/raffleResendReceipt`,
  publicGet: `${FN}/rafflePublicGet`,
  reserve: `${FN}/raffleReserve`,
  createIntent: `${FN}/raffleCreateIntent`,
  confirmPayment: `${FN}/raffleConfirmPayment`,
  uploadImage: `${FN}/raffleUploadImage`,
  onlineIntent: `${FN}/raffleOnlineIntent`,
  onlineConfirm: `${FN}/raffleOnlineConfirm`,
  markDeposited: `${FN}/raffleMarkDeposited`,
};

export const PUBLIC_BASE = 'https://bbtc-dashboard.web.app/sorteo';
export const raffleUrl = (token) => `${PUBLIC_BASE}?r=${token}`;
export const saleUrl = (token) => `${PUBLIC_BASE}?t=${token}`;

export const SALE_STATUS_LABELS = {
  pending: 'Pendiente de pago',
  paid: 'Pagado',
  cancelled: 'Cancelado',
  expired: 'Reserva vencida',
};
export const SALE_STATUS_COLORS = { pending: 'warning', paid: 'success', cancelled: 'error', expired: 'default' };
export const METHOD_LABELS = { cash: 'Efectivo', ath: 'ATH Móvil', card: 'Tarjeta', other: 'Otro' };
export const SOURCE_LABELS = { admin: 'Mostrador', online: 'En línea' };

export const money = (cents) => `$${((Number(cents) || 0) / 100).toFixed(2)}`;

export function fmtDateEs(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).split('-').map(Number);
  const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  return `${d} de ${months[m - 1]} de ${y}`;
}

// "#312, #313, #320" con rangos seguidos "#401–#405"
export function numbersLabel(nums) {
  const sorted = [...new Set((nums || []).map(Number))].filter((n) => n > 0).sort((a, b) => a - b);
  const parts = [];
  let start = null;
  let prev = null;
  sorted.forEach((n) => {
    if (start === null) { start = n; prev = n; return; }
    if (n === prev + 1) { prev = n; return; }
    parts.push(start === prev ? `#${start}` : `#${start}–#${prev}`);
    start = n; prev = n;
  });
  if (start !== null) parts.push(start === prev ? `#${start}` : `#${start}–#${prev}`);
  return parts.join(', ');
}

// "312, 313-315, 320" → [312, 313, 314, 315, 320]
export function parseNumbers(text) {
  const out = new Set();
  String(text || '').split(/[,\s;]+/).forEach((part) => {
    const p = part.replace(/#/g, '').trim();
    if (!p) return;
    const m = p.match(/^(\d+)\s*[-–]\s*(\d+)$/);
    if (m) {
      const a = Number(m[1]); const b = Number(m[2]);
      if (a > 0 && b >= a && b - a < 500) for (let n = a; n <= b; n += 1) out.add(n);
    } else if (/^\d+$/.test(p)) out.add(Number(p));
  });
  return [...out].sort((a, b) => a - b);
}

export function randomToken(bytes = 16) {
  const arr = new Uint8Array(bytes);
  window.crypto.getRandomValues(arr);
  return Array.from(arr, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result).split(',')[1]);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

export async function callFn(url, body) {
  const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}) });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Error ${res.status}`);
  return data;
}

export function downloadCsv(filename, rows) {
  if (!rows.length) return;
  const keys = Object.keys(rows[0]);
  const esc = (v) => `"${String(v == null ? '' : v).replace(/"/g, '""')}"`;
  const csv = [keys.join(','), ...rows.map((r) => keys.map((k) => esc(r[k])).join(','))].join('\n');
  const blob = new Blob([String.fromCharCode(0xfeff) + csv], { type: 'text/csv;charset=utf-8;' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}

export const EMPTY_RAFFLE = {
  name: '',
  prize: '',
  description: '',
  drawDate: '',
  venue: '',
  ticketPrice: '100',
  totalTickets: '500',
  onlineFrom: '',
  onlineTo: '',
  onlineEnabled: true,
  terms: 'No tienes que estar presente para ganar. Los boletos no son reembolsables.',
  // Reglas y condiciones completas (una viñeta por línea). Se muestran en la
  // página pública en un acordeón ES/EN y el comprador debe aceptarlas.
  rulesEs: '',
  rulesEn: '',
  // Boleto virtual (mismo diseño del boleto físico)
  ticketBrand: '',
  ticketHeadline: 'BOLETO SORTEO',
  ticketFooter: 'B&B Target Center Inc. Licencia de Armero #183543',
  prizeValue: '',
  imageUrl: '',
  contactName: 'B&B Target Center',
  contactPhone: '787-755-9060',
  contactEmail: '',
  status: 'active',
};
